<template>
  <div>
    <v-row>
      <v-col cols="12" sm="12">
        <v-card class="card-border" :disabled="loading">
          <v-card-text>
            <v-form ref="formBusca" @submit.prevent="buscar()">
              <v-row>
                <v-col cols="12" sm="12" md="4">
                  <SelectEmpresa
                    :multiple="true"
                    @onChanged="empresas = $event"
                  />
                </v-col>
                <v-col cols="12" sm="12" md="2">
                  <v-autocomplete
                    v-model="tipoBusca"
                    :items="tipoBuscaSelect"
                    item-text="text"
                    item-value="value"
                  />
                </v-col>
                <v-col cols="12" sm="12" align="center">
                  <v-btn
                    outlined
                    color="blue darken-2"
                    rounded
                    dark
                    depressed
                    small
                    type="submit"
                  >
                    <v-icon left>mdi-magnify</v-icon>Buscar
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col>
        <v-card class="card-border" :disabled="loading">
          <v-card-text>
            <v-data-table
              :headers="table.headers"
              :items="table.data"
              :loading="loading"
              :search="table.search"
              ref="mainTable"
            >
              <template v-slot:top>
                <v-row>
                  <v-col cols="12" sm="12">
                    <v-row>
                      <v-col cols="12" sm="12" md="3"><v-text-field v-model="table.search" placeholder="Procurar..." /></v-col>
                      <v-spacer></v-spacer>
                      <v-col cols="12" sm="12" md="1">
                        <v-btn v-if="table.data.length > 0" @click="printTable()">Imprimir</v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </template>
              <template v-slot:item.possuiUsuario="{ item }">
                <v-icon :color="item.possuiUsuario ? 'green' : 'red'">{{ item.possuiUsuario ? 'mdi-check' : 'mdi-close' }}</v-icon>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Relatorios from '@/services/relatorios'

export default {
  name: 'ColaboradorUsuario',

  components: {
    SelectEmpresa: () => import("@/components/select/SelectEmpresa")
  },

  data() {
    return {
      loading: false,

      empresas: [],
      tipoBusca: '0',
      tipoBuscaSelect: [
        { text: 'Todos', value: '0' },
        { text: 'Possui usuário', value: '1' },
        { text: 'Não possui usuário', value: '2' }
      ],

      table:
      {
        search: '',

        headers:
        [
          {
            text: 'Nome',
            value: 'nome'
          },{
            text: 'Apelido',
            value: 'apelido'
          },{
            text: 'CPF',
            value: 'cpf'
          },{
            text: 'E-mail',
            value: 'email'
          },{
            text: 'Telefone',
            value: 'telefone'
          },{
            text: 'Possui User',
            value: 'possuiUsuario'
          }
        ],

        data: []
      }
    }
  },

  methods: {
    async buscar() {
      if(!this.$refs.formBusca.validate()) return;

      try
      {
        this.loading = true
        let data = await new Relatorios().getColaboradorUsuario(this.empresas, this.tipoBusca)
        this.table.data = data
      }
      catch(error)
      {
        this.$swal.error('', error)
      }
      finally
      {
        this.loading = false
      }
    },

    printTable() {
      let html =
      `<table border="1">
        <thead>
          <th></th>
          <th>Nome</th>
          <th>CPF</th>
          <th>E-mail</th>
          <th>Possui Usuario</th>
        </thead>
        <tbody>`

      let aux = 0
      for(let current of this.table.data)
      {
        aux++
        let possuiUser = current.possuiUsuario ? 'SIM' : 'NÃO'
        html +=
        `<tr>
          <td>${aux}</td>
          <td>${current.nome}</td>
          <td>${current.cpf}</td>
          <td>${current.email}</td>
          <td>${possuiUser}</td>
        </tr>`
      }

      html +=
      `</tbody>
      </table>`

      let newWin = window.open("")
      newWin.document.write(html)
      newWin.print()
      newWin.close()
    }
  },
}
</script>
